var render = function render(){var _vm=this,_c=_vm._self._c;return _c('masked-input',{attrs:{"value":_vm.inputValue,"type":"text","mask":_vm.mask,"show-mask":false},on:{"input":_vm.updateField},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }